import InventoryAgingReportItem  from '@/store/entities/inventory-aging-item';

export default class InventoryAgingReportOutput {
    warehouseCode :string;
    sku:string;
    clientCode:string;
    productName:string;
    warehouseName : string;
    clientName:string;
    items : Array<InventoryAgingReportItem>;
}